import ContentBlocksModule from "./content_blocks_module";
import DifficultWordsModule from "./difficult_words_module";
import GameTemplatesModule from "./game_template_module";
import PartnersModule from "./partners_module";
import QuestionSetsModule from "./question_sets_module";
import RegistrationsModule from "./auth/registrations_module";
import AuthSessionsModule from "./auth/sessions_module";
import SessionsModule from "./sessions_module";
import PasswordsModule from "./auth/passwords_module";
import OpinionsModule from "./opinions_module";

let apiURL: string;
if (import.meta.env.VITE_BACKEND_URL !== undefined) {
  apiURL = import.meta.env.VITE_BACKEND_URL;
} else if (import.meta.env.PROD) {
  apiURL = "/api";
} else {
  apiURL = "http://localhost:4000";
}

export { apiURL };

function createAPIClient(baseURL: string) {
  return {
    auth: {
      passwords: new PasswordsModule(baseURL),
      registrations: new RegistrationsModule(baseURL),
      sessions: new AuthSessionsModule(baseURL),
    },
    contentBlocks: new ContentBlocksModule(baseURL),
    difficultWords: new DifficultWordsModule(baseURL),
    gameTemplates: new GameTemplatesModule(baseURL),
    opinions: new OpinionsModule(baseURL),
    partners: new PartnersModule(baseURL),
    questionSets: new QuestionSetsModule(baseURL),
    sessions: new SessionsModule(baseURL),
  };
}

const APIclient = createAPIClient(apiURL);
export default APIclient;
